import React from 'react'

import { CriteriaForm } from './CriteriaForm'

interface IProps {
  PartnerID: string
  flexWidth?: string
  rid: number
  appSource: string
}

const fields = [
  {
    label: 'Transactional Data Pack for all SKUs',
    code: 'PC_SELLTO',
  },
  {
    label: 'Transactional Data Pack for Supplies SKUs',
    code: 'PC_SBD',
  },
  { label: 'Supplies Share of Business', code: 'PC_SOB_SUPP' },

  { label: 'Managed Data Pack', code: 'PC_MDPK', onlyOptIn: true },
]

export const PowerServiceCriteria = (props: IProps) => {
  return (
    <CriteriaForm
      PartnerID={props.PartnerID}
      fields={fields}
      flexWidth={props.flexWidth}
      rid={props.rid}
      appSource={props.appSource}
    />
  )
}
